module.exports = __webpack_public_path__ + "img/linde_mh_logo_rgb.31985183.png";